import { useEffect, useState } from "react";
import { FaFilePdf } from "react-icons/fa";

/**
 * Base64 PDF'i blob URL'e çevirip iframe içinde gösterir.
 *
 * Blob URL her `pdfBase64` değişiminde yeniden üretilir ve unmount'ta
 * revoke edilir — aksi halde her rapor çekilişinde bir blob sızar.
 */
export default function ReportPdfPreview({ pdfBase64, title = "Rapor Önizleme" }) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!pdfBase64) {
      setBlobUrl(null);
      return undefined;
    }
    const byteChars = atob(pdfBase64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i += 1) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const url = URL.createObjectURL(
      new Blob([new Uint8Array(byteNumbers)], { type: "application/pdf" })
    );
    setBlobUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [pdfBase64]);

  if (!blobUrl) {
    return (
      <div className="flex-1 min-h-0 flex flex-col items-center justify-center bg-white rounded-xl border border-gray-100">
        <FaFilePdf className="w-8 h-8 text-gray-300 mb-2" />
        <p className="text-sm text-gray-500">Önizleme hazırlanıyor...</p>
      </div>
    );
  }

  return (
    <div className="flex-1 min-h-0 bg-white rounded-xl border border-gray-100 overflow-hidden">
      <iframe src={blobUrl} title={title} className="w-full h-full border-0" />
    </div>
  );
}

/**
 * Base64 PDF'i indirir. Sayfa başlığındaki indirme butonu bunu kullanır.
 */
export function downloadPdfFromBase64(pdfBase64, fileName) {
  if (!pdfBase64) return;
  const byteChars = atob(pdfBase64);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i += 1) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  const url = URL.createObjectURL(
    new Blob([new Uint8Array(byteNumbers)], { type: "application/pdf" })
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName?.endsWith(".pdf") ? fileName : `${fileName}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
